module.exports = __webpack_public_path__ + "static/media/Picto_Lead_AltyorHub.40bf529a.svg";